import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CourseRoutingModule } from './course-routing.module';
import { CourseComponent } from './course.component';
import { MaterialModule } from '../shared/material/material.module';
import { SharedModule } from '../shared/shared.module';
import { CourseService } from './course.service';
import { ProgrammeComponent } from './programmes.component';
import { RealizationComponent } from './realization.component';


@NgModule({
  declarations: [
    CourseComponent,
    ProgrammeComponent,
    RealizationComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    CourseRoutingModule
  ],
  providers: [
    CourseService
  ]
})
export class CourseModule { }
